<template>
  <div ref="containerRef" class="flex justify-between">
    <ErrorBoundary>
      <EventBuyBoxPrice
        :kft-event="eventData"
        :selected-time="selectedDate"
        :selected-ticket-quantity="selectedTicketQuantity"
        :type="selectedDateType"
        :loading-pricings="loadingPricings"
      />
      <div v-if="isRequestButtonsVisible" class="flex gap-2 mt-[3px]">
        <client-only>
          <EventBuyBoxWatilistButton
            v-if="showWaitlistButton"
            :display-label="false"
          />
          <EventBuyBoxRequestDateButton
            v-if="showDateRequestButton"
            class="px-2 py-1"
          />
        </client-only>
      </div>
    </ErrorBoundary>
  </div>
</template>

<script lang="ts" setup>
import type {
  EventDate,
  EventDateType,
  EventDescription,
} from '~/composables/types/event'
import EventBuyBoxWatilistButton from '~/components/event/buybox/EventBuyBoxWatilistButton.vue'
import { useIsSubdomain } from '~/composables/useSubdomain'

export interface PropsEventBuyBoxHeader {
  selectedDateType: EventDateType
  selectedTicketQuantity: number
  selectedDate: EventDate | undefined
  availableTickets: number
  isBoxEvent: boolean
  enableSubdomain?: boolean
  isRequestButtonsVisible?: boolean
  loadingPricings?: boolean
}

const props = withDefaults(defineProps<PropsEventBuyBoxHeader>(), {
  selectedDateType: 'PUBLIC',
  selectedDate: undefined,
  selectedTicketQuantity: 1,
  enableSubdomain: false,
  isRequestButtonsVisible: true,
})
const eventData = inject<EventDescription>('eventData')!
const isSubdomain = useIsSubdomain()
const showDateRequestButton = computed(
  () =>
    eventGetters.isDateRequestActiveBS(eventData, isSubdomain.value) &&
    !props.isBoxEvent
)

// Show waitlist button if it's a box event and it's sold out
// If it's not a box, show waitlist
const showWaitlistButton = computed(
  () => !(props.isBoxEvent && props.availableTickets > 0)
)
const containerRef = ref<HTMLElement | undefined>()

const { checkOverflow } = useIsElementOverflowing(containerRef)

watch(
  () => props.selectedDate,
  async () => {
    await nextTick()
    checkOverflow()
  }
)

watch(
  () => props.selectedDateType,
  async () => {
    await nextTick()
    checkOverflow()
  }
)
</script>
